<ng-template #starts let-fill="fill">
    <span class="star" [class.full]="fill === 100">
		<span class="half" [style.width.%]="fill">&#9733;</span>&#9733;
    </span>
</ng-template>
<section class="producto">
    <div class="producto-content">
        <div>
            <section>
                <div class="producto-galeria-lista" *ngIf=" galeria.length > 0 ">
                    <figure *ngFor="let newItem of galeria" (click)="fnCambioImagen( newItem )">
                        <img [src]="newItem.url" loading="lazy" [alt]="newProducto.nombre">
                    </figure>
                </div>
                <div class="producto-galeria-preview" id="imgPreview" [ngStyle]="{'background-image': 'url('+currentImage.url +')'}">
                </div>
            </section>
            <section class="producto-descripcion-amplio">
                <h1 class="titulo color-purple" *ngIf=" newProducto.caracteristicas.length > 0 "> Características</h1>
                <section *ngFor="let newItem of newProducto.caracteristicas | groupBy:'caracteristica'">
                    <h3 class="color-blue"> {{ newItem.key }} </h3>
                    <p *ngFor="let newData of newItem.value"><i class="far fa-dot-circle"></i> &ensp; {{ newData.valor }}</p>
                </section>
                <br>
                <h1 class="titulo color-purple"> Descripción del producto </h1>
                <div class="html" [innerHTML]=" newProducto.descripcionCorta | safe:'html' "></div>
                <br>
                <div class="html" [innerHTML]=" newProducto.descripcionLarga | safe:'html' "></div>
            </section>
        </div>
        <div>
            <h2 class="producto-nombre">{{ newProducto.nombre }}</h2>
            <caption>
                <div class="producto-precio">
                    <h1 class="color-blue">
                        <span class="color-blue" *ngIf=" currentInventarioDetalle.descuento === 0 ">
							{{ currentInventarioDetalle.precio | currency:newProducto.divisa:'symbol':'.2-2' }}
						</span>
                        <span class="color-blue" *ngIf=" currentInventarioDetalle.descuento > 0 ">
							{{ (currentInventarioDetalle.precio - currentInventarioDetalle.descuento) | currency:newProducto.divisa:'symbol':'.2-2' }}
						</span>
                        <br>
                        <span class="color-gris" *ngIf=" currentInventarioDetalle.descuento > 0 ">
							<small>
								Precio anterior: 
								<span>
									{{ currentInventarioDetalle.precio | currency:newProducto.divisa:'symbol':'.2-2' }}
								</span>
                        <span class="color-blue">
									Ahorras:
									{{ currentInventarioDetalle.descuento | currency:newProducto.divisa:'symbol':'.2-2' }}
								</span>
                        </small>
                        </span>
                    </h1>
                </div>
                <div class="producto-descuento"></div>
            </caption>
            <div>
                <div>Marca: {{ newProducto.marca }}</div>
                <div></div>
            </div>
            <div>
                <!-- {{ listaResenias.length }} reseñas -->
                <!-- <ngb-rating [(rate)]="currentInventarioDetalle.calificacion" [starTemplate]="starts" [readonly]="true" max="5"></ngb-rating> ({{ currentInventarioDetalle.calificacion }}) -->
            </div>
            <div *ngIf="permiteEnvioMismoDia" class="producto-promo">
                <img src="assets/images/promo-envio-gratis.svg" loading="lazy" alt="Envio Gratis" />
            </div>
            <div *ngIf="permiteEnvioMismoDia">
                <p class="color-blue">¿Quieres recibir tu pedido hoy <span class="color-blue-bold">({{ currentDay }})</span>?</p>
                <p>Cómpralo antes de las <span class="color-purple-bold">13:00 hrs</span> del día de hoy y <span class="color-purple-bold">elige envío en 1 día</span> al completar tu pedido.</p>
            </div>
            <section class="producto-inventario">
                <div *ngIf=" tieneColores ">
                    <div>Color</div>
                    <div>
                        <app-select (newModelo)="fnSeleccionColor( $event )" [titulo]="tituloColor" [currentModelo]="currentInventario" [listaElementos]="listaInventario"></app-select>
                    </div>
                </div>
                <div *ngIf=" tieneTallas ">
                    <div>Talla</div>
                    <div>
                        <app-select (newModelo)="fnSeleccionTalla( $event )" [titulo]="tituloTalla" [currentModelo]="currentInventarioDetalle" [listaElementos]="listaDetaleInventario"></app-select>
                    </div>
                </div>
                <div>
                    <div>Cantidad</div>
                    <div class="producto-cantidad">
                        <div (click)="fnCambiarCantidad( false )" [ngClass]="{'disabled': ( currentProducto.cantidad  === 1 ) }">
                            <p><i class="fas fa-minus"></i></p>
                        </div>
                        <div>
                            <input type="number" min="1" [(ngModel)]="currentProducto.cantidad" (blur)="fnValidateCantidad()">
                        </div>
                        <div (click)="fnCambiarCantidad( true )" [ngClass]="{'disabled': ( currentProducto.cantidad === currentInventarioDetalle.stock ) }">
                            <p><i class="fas fa-plus"></i></p>
                        </div>
                    </div>
                </div>
            </section>
            <div class="producto-opciones">
                <div>
                    <button class="fondo-green" (click)="fnAgregarProductoCarrito()" *ngIf="currentInventarioDetalle.disponible">
						<i class="fas fa-shopping-cart"></i>
						<span> Añadir al carrito</span>
					</button>
                    <button class="fondo-green-outline" *ngIf="!currentInventarioDetalle.disponible">
						<img src="assets/images/notAvailable.png" loading="lazy" alt="No disponible"/>
						<span>   NO DISPONIBLE</span>
					</button>
                </div>
                <div *ngIf=" newProducto.onWishlist && newUser.session ">
                    <button class="fondo-purple" (click)="fnWishlist( false )">
						<img src="assets/images/wishListEnabled.png" loading="lazy" alt="WishList"/>
						<span>   Quitar de mi Wishlist</span>
					</button>
                </div>

                <div *ngIf=" !newProducto.onWishlist && newUser.session ">
                    <button class="fondo-blue" (click)="fnWishlist( true )">
						<img src="assets/images/wishListDisabled.png" loading="lazy" alt="Añadir a mi WishList"/>
						<span> Añadir a mi Wishlist</span>
					</button>
                </div>
            </div>
            <div class="producto-opciones fbShareBtn">
            </div>
            <section class="producto-descripcion-movil">
                <h1 class="titulo color-purple" *ngIf=" newProducto.caracteristicas.length > 0 "> Características</h1>
                <section *ngFor="let newItem of newProducto.caracteristicas | groupBy:'caracteristica'">
                    <h3 class="color-blue"> {{ newItem.key }} </h3>
                    <p *ngFor="let newData of newItem.value"><i class="far fa-dot-circle"></i> &ensp; {{ newData.valor }}</p>
                </section>
                <br>
                <h1 class="titulo color-purple"> Descripción del producto </h1>
                <p [innerHTML]=" newProducto.descripcionCorta | safe:'html' "></p>
                <p [innerHTML]=" newProducto.descripcionLarga | safe:'html' "></p>
            </section>
        </div>
    </div>
</section>
<section class="tarjetas">
    <app-slider [lista]="listaRelacionados" [tipo]="'3'" [numberOfShow]="numberOfShow" [alto]="425" [numberOfSlide]="2" [ancho]="anchoCarousel"></app-slider>
</section>
<!--
<section class="producto-resenias">
	<h1>
		<span *ngIf=" listaResenias.length > 0 " class="color-purple-bold">
			{{ listaResenias.length }} Reseñas de este producto
		</span>
		<span *ngIf=" listaResenias.length === 0 " class="color-purple-bold">
			Este producto no tiene reseñas
		</span>
		<button class="fondo-purple-outline" *ngIf=" permisos ">
			<i class="color-purple far fa-edit"></i> Escribir una reseña
		</button>
	</h1>
	<div class="producto-resenias-paginador" *ngIf=" listaResenias.length > 0 ">
		<app-paginador (eventSuccess)="fnPaginarResenias( $event )" (eventFail)="fnErrorPaginador( $event )" [totalPaginas]="paginacion.totalPaginas"></app-paginador>
	</div>
	<section class="producto-resenias-contenido" *ngIf=" listaResenias.length > 0 ">
		<div class="producto-resenias-contenido-item" *ngFor="let newResenia of listaResenias | slice:paginacion.currentOffset:paginacion.currentItems">
			<h2 class="color-blue">{{ newResenia.titulo }}</h2>
			<small class="color-purple-bold"> {{ newResenia.creacion }} - {{ newResenia.cliente }}</small>
			<p>{{ newResenia.contenido }}</p>
			<div>
				<span class="color-purple-bold">Calificación: </span>
				<ngb-rating class="start-medium" [(rate)]="newResenia.estrellas" [starTemplate]="starts" [readonly]="true" max="5"></ngb-rating>
			</div>
		</div>
	</section>
	<div class="producto-resenias-paginador" *ngIf=" listaResenias.length > 0 ">
		<app-paginador (eventSuccess)="fnPaginarResenias( $event )" (eventFail)="fnErrorPaginador( $event )" [totalPaginas]="paginacion.totalPaginas"></app-paginador>
	</div>
</section>

<section class="producto-preguntas">
	<h1>
		<span *ngIf=" listaPreguntas.length > 0 " class="color-green-bold">
			{{ listaPreguntas.length }} Preguntas a este producto
		</span>
		<span *ngIf=" listaPreguntas.length === 0 " class="color-green-bold">
			Este producto no tiene preguntas
		</span>
		<button class="fondo-green-outline" *ngIf=" permisos ">
			<i class="color-green far fa-comment-alt"></i> Hacer una pregunta
		</button>
	</h1>
	<section class="producto-preguntas-contenido">
		<div class="producto-preguntas-contenido-item" *ngFor="let newPregunta of listaPreguntas">
			
			<section class="producto-preguntas-contenido-item-header">
				<section>
					<div> <i class="color-green far fa-comment-alt fa-2x"></i> </div>
					<div>
						<small class="color-black-bold">{{ newPregunta.contenido }}</small>
					</div>
				</section>
				<div>
					<small class="color-purple-bold"> {{ newPregunta.creacion }} - {{ newPregunta.cliente }}</small>
				</div>
			</section>
			<section class="producto-preguntas-contenido-item-body" *ngFor="let newRespuesta of newPregunta.respuestas">
				<p>{{ newRespuesta.creacion }} - {{ newRespuesta.contenido }}</p>
			</section>
			<style type="text/css">
				
				
			</style>
			
		</div>
	</section>
</section>
-->